<template>
  <transition name="slide-fade">
    <div id="aboutusHolder">
      <!--<div class=" uk-background-secondary uk-light" style="padding: 20px; color: rgb(197,179,88) !important;">
        <div class="uk-container uk-container-small">
          <p class="uk-text-center uk-text-lead@l uk-text-large@l ">
            <i>"Your future is important, landscape it the right way "</i>
          </p>
        </div>
      </div>-->
      <div class="uk-padding">
        <h1 class="uk-heading-line specHeading uk-text-center"><span>Career and Employment Services</span></h1>
        <div class="uk-container uk-container-small">
          <div class="uk-child-width-1-2@m" uk-grid>
            <p class=" ">
              NCU’s Career and Employment Services is here to help you start your career journey!
              The office of Career and Employment Services (CES) wants to help you make your time here an exciting and relevant one.

            </p>
            <div class="uk-visible@m">
              <img class="uk-align-center" src="../assets/careerservices.jpg" >
            </div>
          </div>


        </div>
      </div>
      <div class="uk-padding uk-background-muted">

        <div class="uk-container uk-container-small">
          <div class="uk-child-width-1-2@m" uk-grid>
            <div>
              <h3 class="uk-heading-bullet specHeading">Service Offerings:</h3>
              <small >Services are offered to assist students to manage their careers and develop career readiness competencies. Four pillars are outlined:
              </small>
              <ul class="uk-list uk-list-bullet ">
                <span class="uk-text-bold">Year 1: Self-Exploration:</span>
                <li>Career & Personality Testing</li>
                <li>Career Advising/ Coaching</li>
                <li>Seminars: Career Planning & Management and Career Readiness Skills</li>

              </ul>
              <ul class="uk-list uk-list-bullet ">
                <span class="uk-text-bold">Year 2: Career Exploration</span>
                <li>Seminars – Basics of Resume & Cover Letter Writing</li>
                <li>Job Fair</li>
                <li>Internship, Work & Travel Cultural Exchange Programme, Summer Employment (local)
                </li>

              </ul>


            </div>
            <div>
              <h3 class="uk-heading-line specHeading"></h3>
              <br>
              <ul class="uk-list uk-list-bullet ">
                <span class="uk-text-bold">Year 3: Training & Education</span>
                <li>Graduate Education Information</li>
                <li>Seminars – Interviewing Techniques, Business & Professional Etiquette</li>
                <li>Career Expo</li>
                <li>Practicum/ Internship</li>

              </ul>
              <ul class="uk-list uk-list-bullet ">
                <span class="uk-text-bold"> Year 4: Job Search</span>
                <li>Seminar – Advanced Resume & Cover Letter Writing, Job Search Strategies</li>
                <li>Job Fair</li>
                <li>Job Placement / Internships/ Practicum</li>
                <li>Interview Techniques and Mock Interviews</li>

              </ul>

            </div>
            <div>
              <div class=" uk-child-width-1-2@l uk-child-width-1-2@s" uk-grid>
                <div>
                  <img class="uk-border-circle" src="../assets/sb.jpg" width="200" height="200" alt="Border circle">
                </div>
                <div>
                  <img class="uk-border-circle" src="../assets/sb1.jpg" width="200" height="200" alt="Border circle">
                </div>


              </div>
            </div>
            <div>
              <div class=" uk-child-width-1-2@l uk-child-width-1-2@s" uk-grid>

                <div>
                  <img class="uk-border-circle" src="../assets/sb2.jpg" width="200" height="200" alt="Border circle">
                </div>
                <div>
                  <img class="uk-border-circle" src="../assets/sb3.jpg" width="200" height="200" alt="Border circle">
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>

    </div>
  </transition>
</template>

<script>
    export default {
        name: "careerservices",
      mounted(){
        window.scrollTo(0, 0);
      },
      metaInfo: {
        // Children can override the title.
        title: 'NCU Career & Employment Services',
        // Result: My Page Title ← My Site
        // If a child changes the title to "My Other Page Title",
        // it will become: My Other Page Title ← My Site
        //titleTemplate: '%s ← My Site',
        // Define meta tags here.
        meta: [
          {'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8'},
          {name: 'viewport', content: 'width=device-width, initial-scale=1'},
          {name: 'description', content: 'Department of Career & Employment Services at Northern Caribbean University '}
        ]
      }
    }
</script>

<style scoped>

</style>
